import React, { Component } from "react";
import "./Footer.scss"

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="footer">
          <div className="padding">
            <div className="policy">
              <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">תנאי שימוש</a> | <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">מדיניות פרטיות</a> | <a href="https://yit.co.il/" target="_blank">אפיון, עיצוב ופיתוח</a>
            </div>
            <div className="yitcredit" onClick={()=> {
                  window.open("https://yit.co.il/", "_blank");
                }}>
                {/* <div className="text">| אפיון, עיצוב ופיתוח</div> */}
                <div className="yitlogo"></div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx